import firebase from 'firebase';
import firebaseConfig from "./../config";
import {getSnapshot, onPatch} from "mobx-state-tree";

import md5 from 'crypto-js/md5';

export default class FirebaseModel {

    constructor(persistStore) {
        this.persistStore = persistStore;

        if (!firebase.apps.length) {
            firebase.initializeApp(firebaseConfig);
        }


        this.database = firebase.database();
        //const mainRef = this.database.ref(`/main/data`);
        firebase.auth().onAuthStateChanged(function(user) {
            //console.log('inside firebase.auth().onAuthStateChanged');
            if (user) {
                // User is signed in.
                var isAnonymous = user.isAnonymous;
                var uid = user.uid;
                //console.log('uid: ' + uid);
                //We can init the user here too, but currently on profile select
                /*const userRef = firebase.database().ref(`/main/data/${uid}`);
                userRef.push();*/
            } else {
                // User is signed out.
                //console.log('User is signed out.');
            }
        });

    }

    saveOrUpdate(){
        console.log('inside save or update: '+this.persistStore.getUserId());
        //getsnapshot of persist store and apply
        console.log(getSnapshot(this.persistStore), this.persistStore.getUserId())
        const databaseRef = firebase.database().ref(`/main/data/`);
        databaseRef
            .child(this.persistStore.getUserId())
            .set(getSnapshot(this.persistStore));

    }


}
